import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import type { showPopupOptions } from '@adornis/dialog/x-plain-dialog.js';
import { config } from '@ils/config/config.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('ils-speedtest-dialog')
export class ILSSpeedtestDialog extends XDialog<void> {
  // its enough to show max once per page load
  private static alreadyShown = false;

  static override get element_name() {
    return 'ils-speedtest-dialog';
  }
  override render() {
    return html`
      <x-flex space="md" padding="md" ${css({ maxWidth: this.sizes.maxReadableWidth })}>
        <x-h2> Haben Sie Ihre Internetverbindung überprüft? </x-h2>
        <x-text>
          Sie sollten eine Verbindungsgeschwindigkeit von mindestens <b> 2mbit/s im Upload </b> und
          <b> 16mbit/s im Download </b> haben. Diese Geschwindigkeit sollte nicht nur in Ihrem Vertrag vereinbart sein,
          sondern auch wirklich bei Ihnen ankommen, bitte testen Sie die Bandbreite vor jeder Prüfung!
        </x-text>
        <x-text>
          Falls Sie unsicher sind wie schnell Ihre Verbindung ist können Sie Sie auf
          <x-link href="https://speed.cloudflare.com/"> speed.cloudflare.com </x-link> testen lassen. Die zwei großen
          Zahlen unter "Download" und "Upload" sind die relevanten Werte.
        </x-text>
        <x-text>
          Mit Klick auf "Ja, meine Verbindung ist schnell genug", versichern Sie, dass Ihre Verbindung schnell genug für
          Video-Telefonie ist.
        </x-text>

        <div></div>
        <x-h2> Ist Ihre Verbindung schnell genug? </x-h2>
        <x-flex horizontal space="md" space-between>
          <x-button
            @click=${() => {
              localStorage.setItem('speedTestConsent', JSON.stringify(new Date()));
              this.close();
            }}
          >
            Ja
          </x-button>
          <x-button
            @click=${() => XDialog.alert(`Melden Sie sich dringendst unter ${config.get('TECHNICALSUPPORTPHONE')}!`)}
          >
            Nein
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }

  static override showPopup<sT>(options?: showPopupOptions<sT> | undefined): Promise<sT> {
    if (this.alreadyShown) throw new Error('Speedtest dialog already shown this session');
    this.alreadyShown = true;
    return super.showPopup<sT>(options);
  }
}
